import React from 'react';

function ErrorFormIcon() {
    return (
        <>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_1817_9425)">
                    <path
                        d="M7.99967 1.33594C4.31967 1.33594 1.33301 4.3226 1.33301 8.0026C1.33301 11.6826 4.31967 14.6693 7.99967 14.6693C11.6797 14.6693 14.6663 11.6826 14.6663 8.0026C14.6663 4.3226 11.6797 1.33594 7.99967 1.33594ZM8.66634 11.3359H7.33301V10.0026H8.66634V11.3359ZM8.66634 8.66927H7.33301V4.66927H8.66634V8.66927Z"
                        fill="#808080"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1817_9425">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </>
    );
}

export default ErrorFormIcon;
